<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="$t('scenario.knowledgeRepresentationScenarioElement') + ' ' + count"
    />

    <v-container class="px-12 pt-7 pb-1 mt-2" fluid>
      <v-row
        class="elevation-4 px-4 mx-1 py-1 mb-4 mt-n2 white"
        dense
      >
        <v-col cols="12">
          <b class="text-capitalize">{{ $t('scenario.element') }}</b>
        </v-col>
        <v-col cols="12">
          <v-chip
            color="secondary"
            class="px-5 pt-0 mr-1 my-1 black--text font-weight-bold"
          >
            {{ !showLogicalLanguage ? (element.name ? element.name : $t('global.notranslation')) : (element.prolog ? element.prolog : $t('global.notranslation')) }}
          </v-chip>
        </v-col>
      </v-row>
      <!-- choose obtaining -->
      <choose-element-parameters
        v-if="!obtainingValidated"
        @chooseElementParameter="chooseObtaining($event)"
        :possible-values="['observation', 'database', 'calculus']"
        :label="$t('scenario.howToGetThisElement')"
        :value="choosenObtaining"
      />
      <!-- validate obtaining button -->
      <v-row
        v-show="choosenObtaining && !obtainingValidated"
        no-gutters
        justify="center"
        class="pt-2"
      >
        <raison-button
          :button-label="$t('global.validate')"
          :button-function="validateObtaining"
        />
      </v-row>
      <!-- validated Obtaining -->
      <editable-chip-block
        v-if="obtainingValidated"
        @edit="editObtaining"
        :label="$t('scenario.obtaining')"
        :value="choosenObtaining"
      />
      <!-- calculus and conditions -->
      <template v-if="obtainingValidated && !conditionsValidated">
        <v-row
          dense
          class="elevation-1 px-4 mx-1 mb-6 py-4 my-5 grey lighten-2"
        >
          <v-col cols="6">
            <h3 class="pa-3">{{ $t('scenario.explainCalculus') }}:</h3>
          </v-col>
          <v-col cols="6">
            <h3 class="pa-3">{{ $t('scenario.areThereConditions') }} ?</h3>
          </v-col>
          <v-col cols="6">
            <v-textarea
              v-model="calculus"
              solo
              :label="$t(`scenario.${choosenObtaining}`)"
            />
          </v-col>
          <v-col cols="6">
            <v-textarea
              v-model="conditions"
              solo
              :label="$t('scenario.conditions')"
            />
          </v-col>
        </v-row>
        <v-row
          no-gutters
          justify="center"
          class="pt-2"
        >
          <raison-button
            :button-label="$t('global.validate')"
            :button-function="validateConditions"
          >
            <template v-slot:append>
              <v-icon right>mdi-arrow-right</v-icon>
            </template>
          </raison-button>
        </v-row>
      </template>
      <!-- natural language -->
      <v-row
        v-if="obtainingValidated && conditionsValidated"
        class="elevation-4 px-4 mx-1 py-1 mb-4 mt-n2 white"
        dense
      >
        <v-col cols="6">
          <b class="text-capitalize">{{ $t('scenario.naturalLanguageOf') }}</b><!-- TODO: add user name -->
        </v-col>
        <v-col cols="6">
          <v-btn
            @click.stop="editConditions"
            class="float-right"
            icon
            color="ternary"
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          {{ calculus }}
        </v-col>
      </v-row>
      <!-- Modify natural language -->
      <template v-if="obtainingValidated && conditionsValidated && !logicalLanguageModificationValidated">
        <v-row
          justify="center"
          dense
          class="elevation-1 px-4 mx-1 mb-6 py-4 my-5 grey lighten-2"
        >
          <v-col cols="12">
            <h3 class="pa-3">{{ $t('scenario.modifyLogicalLanguageProposition') }}:</h3>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="logicalLanguageModification"
              solo
              :label="$t(`scenario.${choosenObtaining}`)"
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <raison-button
            :button-label="$t('global.validate')"
            :button-function="validateLogicalLanguageModification"
          />
        </v-row>
      </template>
      <!-- Validated modified logical language -->
      <v-row
        v-if="obtainingValidated && conditionsValidated && logicalLanguageModificationValidated"
        class="elevation-4 px-4 mx-1 py-1 mb-4 mt-n2 white"
        dense
      >
        <v-col cols="12">
          <b class="text-capitalize">{{ $t('scenario.logicalLanguage') }}</b>
        </v-col>
        <v-col cols="12">
          {{ logicalLanguageModification }}
        </v-col>
      </v-row>
      <!-- Define element type -->
      <choose-element-parameters
        v-if="obtainingValidated && conditionsValidated && logicalLanguageModificationValidated && !elementTypeValidated"
        @chooseElementParameter="chooseElementType($event)"
        :possible-values="['fact', 'belief', 'hypothesis']"
        :label="$t('scenario.defineElementType')"
        :value="elementType"
      />
      <v-row
        v-if="obtainingValidated && conditionsValidated && logicalLanguageModificationValidated && elementType !== '' && !elementTypeValidated"
        justify="center"
        dense
      >
        <raison-button
          :button-label="$t('global.validate')"
          :button-function="validateElementType"
        />
      </v-row>
      <!-- elemnt type validated -->
      <editable-chip-block
        v-if="obtainingValidated && conditionsValidated && logicalLanguageModificationValidated && elementTypeValidated"
        @edit="editElementType"
        :label="$t('scenario.elementType')"
        :value="elementType"
      />
      <!-- Validate and go to next element -->
      <v-row
        v-if="obtainingValidated && conditionsValidated && logicalLanguageModificationValidated && elementTypeValidated"
        justify="center"
        dense
      >
        <raison-button
          :button-label="$t('scenario.validateAndGoToNextElement')"
          :button-function="validateAndGoToNextElement"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import RaisonButton from '@/components/global/RaisonButton';
import ChooseElementParameters from '@/components/scenarioElements/ChooseElementParameters';
import EditableChipBlock from '@/components/scenarioElements/EditableChipBlock';

import projectPageMixin from '@/mixins/project-page-mixin.js';

export default {
  name: 'ScenarioElements',

  components: { PageContentToolbar, RaisonButton, ChooseElementParameters, EditableChipBlock },

  mixins: [ projectPageMixin ],

  data () {
    return {
      count: '1/45',// TODO: stop mocking
      element: {id: 666, name: 'Element A'}, // TODO: stop mocking
      choosenObtaining: undefined,
      obtainingValidated: false,
      conditionsValidated: false,
      conditions: '',
      calculus: '',
      logicalLanguageModification: '',
      logicalLanguageModificationValidated: false,
      elementType: '',
      elementTypeValidated: false,
    };
  },

  methods: {
    chooseObtaining (obtaining) {
      this.choosenObtaining = obtaining;
    },

    validateObtaining () {
      this.obtainingValidated = true;
    },

    editObtaining () {
      this.obtainingValidated = false;
    },

    validateConditions () {
      this.conditionsValidated = true;
    },

    editConditions () {
      this.conditionsValidated = false;
    },

    validateLogicalLanguageModification () {
      this.logicalLanguageModificationValidated = true;
    },

    chooseElementType (type) {
      this.elementType = type;
    },

    validateElementType () {
      this.elementTypeValidated = true;
    },

    editElementType () {
      this.elementTypeValidated = false;
    },

    validateAndGoToNextElement () {
      // TODO: implementer. Est-ce qu'on va a un element suivant ? une autre page ? on contacte l'api ?...
      this.$router.push({name: 'conflictResolution', params: { id: this.$route.params.id } });
    }
  },
};
</script>